import { message, Modal } from "antd";
import React from "react";
import { Button } from "reactstrap";

function NotificationDetails({
  readNotification,
  notification,
  onCloseNotificationDetails,
  getList,
  page,
}) {
  const continueButton = () => {
    // let string = JSON.stringify(html);
    readNotification(notification.id).then((res) => {
      if (res.id) {
        message.success("Notification successfully updated");
      }

      getList();
    });

    onCloseNotificationDetails();
  };

  return (
    <>
      <Modal
        onCancel={onCloseNotificationDetails}
        footer={[]}
        isOpen={true}
        visible={true}
      >
        <div className="author">
          <h5 className="title">Notification details</h5>
          <p className="">Type: {notification.notificationType}</p>
          <span>
            Status:{" "}
            {notification.isRead ? (
              <span style={{ color: "blue", marginLeft: "5px" }}>Read</span>
            ) : (
              <span style={{ color: "red", marginLeft: "5px" }}>Not Read</span>
            )}
          </span>
          <p style={{ marginBottom: "0px" }}>
            Sent on:{" "}
            {new Date(notification.sentDate).toLocaleString("en-US", {
              timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            })}
          </p>
        </div>
        <p>Message:</p>
        <p className="text-center">{notification.body}</p>

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          {!notification.isRead && (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={continueButton}
                color="primary"
                size="md"
                className="btn-round"
              >
                Read
              </Button>
            </div>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginLeft: "5px",
            }}
          >
            <Button
              onClick={() => {
                window.open(
                  `${notification.path}`,
                  "_blank"
                  // "noreferrer"
                );
              }}
              color="info"
              size="md"
              className="btn-round"
            >
              Go to link
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default NotificationDetails;
